import { z } from 'zod'

export const STRATALYST_ROLES_TEAM_CONTRACT_VERSION = '1.0.0' as const
const passthroughResponseSchema = z.unknown()

export const stratalystRolesAssignmentsListResponseSchema = passthroughResponseSchema
export const stratalystRolesAssignmentsCreateResponseSchema = passthroughResponseSchema
export const stratalystRolesAssignmentsRevokeResponseSchema = passthroughResponseSchema
export const stratalystTeamsListResponseSchema = passthroughResponseSchema
export const stratalystTeamsCreateResponseSchema = passthroughResponseSchema
export const stratalystTeamsDeleteResponseSchema = passthroughResponseSchema
export const stratalystTeamMembersListResponseSchema = passthroughResponseSchema
export const stratalystTeamMembersCreateResponseSchema = passthroughResponseSchema
export const stratalystTeamMembersDeleteResponseSchema = passthroughResponseSchema

export type StratalystRolesAssignmentsListResponse = z.infer<typeof stratalystRolesAssignmentsListResponseSchema>
export type StratalystRolesAssignmentsCreateResponse = z.infer<typeof stratalystRolesAssignmentsCreateResponseSchema>
export type StratalystRolesAssignmentsRevokeResponse = z.infer<typeof stratalystRolesAssignmentsRevokeResponseSchema>
export type StratalystTeamsListResponse = z.infer<typeof stratalystTeamsListResponseSchema>
export type StratalystTeamsCreateResponse = z.infer<typeof stratalystTeamsCreateResponseSchema>
export type StratalystTeamsDeleteResponse = z.infer<typeof stratalystTeamsDeleteResponseSchema>
export type StratalystTeamMembersListResponse = z.infer<typeof stratalystTeamMembersListResponseSchema>
export type StratalystTeamMembersCreateResponse = z.infer<typeof stratalystTeamMembersCreateResponseSchema>
export type StratalystTeamMembersDeleteResponse = z.infer<typeof stratalystTeamMembersDeleteResponseSchema>
